import * as blackList from '../services/blackList';

export default {
  namespace: 'blackList',

  state: {},

  effects: {
    *getBlackList({ payload: { values } }, { call, put }) {
      const response = yield call(blackList.getBlackList, values);
      yield put({
        type: 'save',
        payload: {
          blackList: response?.data,
        },
      });
    },

    *deleteBlack({ payload: { values }, callback }, { call }) {
      const response = yield call(blackList.deleteBlack, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
